import { render, staticRenderFns } from "./ProjectTokens.vue?vue&type=template&id=5b6bfa13"
import script from "./ProjectTokens.vue?vue&type=script&lang=js"
export * from "./ProjectTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports